import ServiceMenu from '../../services/Menu';
import Helper from '../../helpers/Helper';
import { scrollIntoElement } from '../scroll/actions';
import { HTTP_STATUS_CODE, SCROLL_TO_TYPE } from '../../helpers/constants';

export const LOADING_MENU = 'LOADING_MENU';
export function loadingMenu() {
  return {
    type: LOADING_MENU,
  };
}

export const RECEIVE_MENUS = 'RECEIVE_MENUS';
export function receiveMenus(menus) {
  return {
    type: RECEIVE_MENUS,
    payload: menus,
  };
}

export const MENU_ERROR = 'MENU_ERROR';
function menuError(error) {
  return {
    type: MENU_ERROR,
    error,
  };
}

export const PUBLISH_MENU_SUCCESS = 'PUBLISH_MENU_SUCCESS';
function publishMenuSuccess() {
  return {
    type: PUBLISH_MENU_SUCCESS,
  };
}

export const FINISH_PUBLISH_MENU = 'FINISH_PUBLISH_MENU';
export function finishPublishMenu() {
  return {
    type: FINISH_PUBLISH_MENU,
  };
}

export const DELETE_MENU_SUCCESS = 'DELETE_MENU_SUCCESS';
function deleteMenuSuccess() {
  return {
    type: DELETE_MENU_SUCCESS,
  };
}

export const FINISH_DELETE_MENU = 'FINISH_DELETE_MENU';
export function finishDeleteMenu() {
  return {
    type: FINISH_DELETE_MENU,
  };
}

export const CREATE_MENU_SUCCESS = 'CREATE_MENU_SUCCESS';
function createMenuSuccess(menu) {
  return {
    type: CREATE_MENU_SUCCESS,
    payload: menu,
  };
}

export const CREATE_MENU_FAILURE = 'CREATE_MENU_FAILURE';
function createMenuFailure(error) {
  return {
    type: CREATE_MENU_FAILURE,
    error,
  };
}

export const FINISH_CREATE_MENU = 'FINISH_CREATE_MENU';
export function finishCreateMenu() {
  return {
    type: FINISH_CREATE_MENU,
  };
}

export const EDIT_MENU_SUCCESS = 'EDIT_MENU_SUCCESS';
function editMenuSuccess(menu) {
  return {
    type: EDIT_MENU_SUCCESS,
    payload: menu,
  };
}

export const EDIT_MENU_FAILURE = 'EDIT_MENU_FAILURE';
function editMenuFailure(error) {
  return {
    type: EDIT_MENU_FAILURE,
    error,
  };
}

export const FINISH_EDIT_MENU = 'FINISH_EDIT_MENU';
export function finishEditMenu() {
  return {
    type: FINISH_EDIT_MENU,
  };
}

export const DELETE_MENU_FAILURE = 'DELETE_MENU_FAILURE';
function deleteMenuFailure() {
  return {
    type: DELETE_MENU_FAILURE,
  };
}

export const CLEAR_MENU_ERRORS = 'CLEAR_MENU_ERRORS';
export function clearMenuErrors() {
  return {
    type: CLEAR_MENU_ERRORS,
  };
}

export const getMenus = () => {
  return async dispatch => {
    try {
      dispatch(loadingMenu());
      const response = await new ServiceMenu().getAll();
      if (response) {
        dispatch(receiveMenus(response.data || []));
        return response.data;
      }
      dispatch(
        menuError({
          error: true,
        })
      );
    } catch (err) {
      console.error('error', err);
      dispatch(
        menuError({
          error: true,
        })
      );
    }
  };
};

export function publishMenu(published, menu) {
  return async dispatch => {
    dispatch(loadingMenu());
    try {
      await new ServiceMenu().patch(menu.id, { published, merchantId: menu.merchantId });
      dispatch(publishMenuSuccess());
    } catch (error) {
      console.error('error', error);
    }
  };
}

export function deleteMenu(id) {
  return async dispatch => {
    dispatch(loadingMenu());
    try {
      const response = await new ServiceMenu().delete(id);
      if (!response) {
        throw new Error('DELETE MENU REQUEST ERROR');
      }
      dispatch(deleteMenuSuccess());
    } catch (error) {
      dispatch(deleteMenuFailure());
      console.error('error', error);
    }
  };
}

export function createMenu(menu) {
  return async dispatch => {
    dispatch(loadingMenu());
    try {
      const response = await new ServiceMenu().post(menu);
      if (response.status !== HTTP_STATUS_CODE.CREATED) {
        throw new Error('Erro na criação de cardápio');
      }
      dispatch(
        scrollIntoElement(Helper.formatItemToScrollInto(response.data, SCROLL_TO_TYPE.menu))
      );
      dispatch(createMenuSuccess(response.data));
    } catch (error) {
      const message =
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.name
          ? error.response.data.message.name
          : 'Erro na criação do cardápio';

      dispatch(createMenuFailure({ message }));

      console.error('error', error);
    }
  };
}

export function editMenu(menu) {
  return async dispatch => {
    dispatch(loadingMenu());
    try {
      const response = await new ServiceMenu().put(menu);
      if (response.status !== HTTP_STATUS_CODE.CREATED) {
        throw new Error('Erro na criação de cardápio');
      }
      dispatch(
        scrollIntoElement(Helper.formatItemToScrollInto(response.data, SCROLL_TO_TYPE.menu))
      );
      dispatch(editMenuSuccess(response.data));
    } catch (error) {
      dispatch(
        editMenuFailure({
          message: 'Erro na criação de cardápio',
        })
      );
      console.error('error', error);
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/menu/actions.js